import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const ShareStudyIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.03 12.6675C12.42 12.315 12.93 12.09 13.5 12.09C14.7075 12.09 15.69 13.0725 15.69 14.28C15.69 15.4875 14.7075 16.47 13.5 16.47C12.2925 16.47 11.31 15.4875 11.31 14.28C11.31 14.115 11.3325 13.95 11.37 13.7925L6.03 10.6725C5.625 11.0475 5.0925 11.28 4.5 11.28C3.255 11.28 2.25 10.275 2.25 9.03003C2.25 7.78503 3.255 6.78003 4.5 6.78003C5.0925 6.78003 5.625 7.01253 6.03 7.38753L11.3175 4.30503C11.28 4.13253 11.25 3.96003 11.25 3.78003C11.25 2.53503 12.255 1.53003 13.5 1.53003C14.745 1.53003 15.75 2.53503 15.75 3.78003C15.75 5.02503 14.745 6.03003 13.5 6.03003C12.9075 6.03003 12.375 5.79753 11.97 5.42253L6.6825 8.50503C6.72 8.67753 6.75 8.85003 6.75 9.03003C6.75 9.21003 6.72 9.38253 6.6825 9.55503L12.03 12.6675ZM14.25 3.78003C14.25 3.36753 13.9125 3.03003 13.5 3.03003C13.0875 3.03003 12.75 3.36753 12.75 3.78003C12.75 4.19253 13.0875 4.53003 13.5 4.53003C13.9125 4.53003 14.25 4.19253 14.25 3.78003ZM4.5 9.78003C4.0875 9.78003 3.75 9.44253 3.75 9.03003C3.75 8.61753 4.0875 8.28003 4.5 8.28003C4.9125 8.28003 5.25 8.61753 5.25 9.03003C5.25 9.44253 4.9125 9.78003 4.5 9.78003ZM12.75 14.295C12.75 14.7075 13.0875 15.045 13.5 15.045C13.9125 15.045 14.25 14.7075 14.25 14.295C14.25 13.8825 13.9125 13.545 13.5 13.545C13.0875 13.545 12.75 13.8825 12.75 14.295Z"
        fill={getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default ShareStudyIcon;
